import { render, staticRenderFns } from "./WorkerAvatar.vue?vue&type=template&id=1a7fde4e"
import script from "./WorkerAvatar.vue?vue&type=script&lang=ts"
export * from "./WorkerAvatar.vue?vue&type=script&lang=ts"
import style0 from "./WorkerAvatar.vue?vue&type=style&index=0&id=1a7fde4e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports